import { useEffect, useState } from "react";

/**
 * Reactive viewport-based mobile detector.
 * Threshold: ≤ 767px (Tailwind `md` breakpoint).
 * Tablets in landscape (>= 768px) render the full desktop UI as required by
 * Batch B3 ("Desktop and tablet access must remain unchanged").
 */
const MOBILE_MAX_WIDTH = 767;

function readIsMobile() {
  if (typeof window === "undefined") return false;
  return window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;
}

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(readIsMobile);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mql = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const handler = (e) => setIsMobile(e.matches);
    // Safari <14 fallback
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  }, []);

  return isMobile;
}
